import { FC } from 'react';
import useCourse from '../../hooks/useCourse';
import useInputSerial from '../../hooks/useInputSerial';
import useSerialCetification from '../../hooks/useSerialCetification';
import PageLoadingLayer from '../Templates/PageLoadingLayer';
import styles from './InputSerial.module.scss';

const InputSerial: FC = () => {
  const useInputSerialValue = useInputSerial();
  const useSerialCetificationValue = useSerialCetification();
  const { courseName } = useCourse();

  return (
    <>
      {useSerialCetificationValue.isCallingApi && <PageLoadingLayer />}
      <div className={`${styles['serial-activation']} ${styles['mod-serial']}`}>
        <div className={styles['main-container']}>
          <div className={styles['form-logo-outer']}>
            <figure>
              <div className={styles['product-logo']} />
            </figure>
          </div>
          <h1 className={`${styles['h1-title']} ${styles['mod-serial']}`}>
            シリアル認証
          </h1>
          <div className={styles['serial-description']}>
            <p>
              スーパーエルマー{courseName}の製品シリアル番号を入力してください。
            </p>
          </div>

          <div className={styles['form-container']}>
            <form>
              <div className={styles['form-container-upper']}>
                <input
                  type="text"
                  name="serialHead"
                  className={`${styles['form-input-text']} ${styles['mod-5']}`}
                  placeholder="ABCDE"
                  maxLength={5}
                  required
                  pattern="[A-Za-z]{5}"
                  onChange={useInputSerialValue.inputSerialOnChange}
                  ref={useSerialCetificationValue.inputSerialRef.serialHeadRef}
                />
                <input
                  type="tel"
                  name="first"
                  className={styles['form-input-text']}
                  placeholder="0000"
                  maxLength={4}
                  minLength={4}
                  required
                  pattern="\d{4}"
                  onChange={useInputSerialValue.inputSerialOnChange}
                  ref={
                    useSerialCetificationValue.inputSerialRef.serialNumFirstRef
                  }
                />
                <input
                  type="tel"
                  name="second"
                  className={styles['form-input-text']}
                  placeholder="1111"
                  maxLength={4}
                  minLength={4}
                  required
                  pattern="\d{4}"
                  onChange={useInputSerialValue.inputSerialOnChange}
                  ref={
                    useSerialCetificationValue.inputSerialRef.serialNumSecondRef
                  }
                />
                <input
                  type="tel"
                  name="third"
                  className={styles['form-input-text']}
                  placeholder="2222"
                  maxLength={4}
                  minLength={4}
                  required
                  pattern="\d{4}"
                  onChange={useInputSerialValue.inputSerialOnChange}
                  ref={
                    useSerialCetificationValue.inputSerialRef.serialNumThirdRef
                  }
                />
                <input
                  type="tel"
                  name="fourth"
                  className={styles['form-input-text']}
                  placeholder="3333"
                  maxLength={4}
                  minLength={4}
                  required
                  pattern="\d{4}"
                  onChange={useInputSerialValue.inputSerialOnChange}
                  ref={
                    useSerialCetificationValue.inputSerialRef.serialNumFourthRef
                  }
                />
              </div>
              <div className={styles['form-container_bottom']}>
                <div className={styles['about-serialcode']}>
                  <a
                    href="https://www.sourcenext.com/r/p/sim/siri"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className={styles['a-inner']}>
                      <p>製品シリアル番号とは？</p>
                      <figure>
                        <div
                          className={`${styles['svg-icon']} ${styles['ic-open-in-new']} ${styles['mod-colorBrandDark']}`}
                        />
                      </figure>
                    </div>
                  </a>
                </div>
              </div>
            </form>
          </div>

          <div className={styles['form-control-container']}>
            <button
              className={`${styles['submit-btn']} ${styles['mod-bordered']}`}
              type="button"
              disabled={useInputSerialValue.isNextButtonDisable}
              onClick={useSerialCetificationValue.onClickNext}
            >
              認証
            </button>
            <div className={`${styles['form-error']} ${styles['is-error']}`}>
              <p>{useSerialCetificationValue.message}</p>
            </div>
          </div>
        </div>
      </div>

      <footer className={styles['app-footer']}>
        <div className={styles['footer-container-licence']}>
          <div className={styles['footer-container-licence-right']}>
            <div className={styles['footer-external-link']}>
              <a
                href="https://www.sourcenext.com/r/p/sim/menu2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className={styles['a-inner']}>
                  <p>ブラウザ版利用時のご注意</p>
                  <figure>
                    <div
                      className={`${styles['svg-icon']} ${styles['ic-open-in-new']} ${styles['mod-colorTertiary']}`}
                    />
                  </figure>
                </div>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default InputSerial;
